import { get } from 'lodash';

import { MODES } from 'constants';
import arrayWrap from 'lib/common/arrayWrap';

const filterByPerformance = (items, perfNo) => {
  return items.filter(i => parseInt(i.perf_no, 10) === perfNo && !parseInt(i.pkg_no, 10));
}

const filterByPackage = (items, pkgNo, perfNo) => {
  return items.filter(i => parseInt(i.pkg_no, 10) === pkgNo && parseInt(i.perf_no, 10) === perfNo);
}

export default function (mode, cart, perfNo, pkgNo) {
  let subLineItems = arrayWrap(get(cart, 'SubLineItem'));
  let packageSubLineItems = arrayWrap(get(cart, 'PackageSubLineItem'));

  /**
   * Filter out unseated package items so we don't try to process them.
   */
  packageSubLineItems = packageSubLineItems.filter(function(item) {
    return parseInt(item.seat_no, 10) !== 0;
  });

  if (mode === MODES.FIXED_PACKAGE) {
    // Deal with this later
  }

  return [].concat(
    filterByPackage(packageSubLineItems, pkgNo, perfNo),
    filterByPerformance(subLineItems, perfNo),
  );
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/combineSubLineItems.js